import React, { forwardRef } from 'react'
import { useStore } from '../../store/store'
import { getPrimaryDark } from '../../constants/constants'

const FloatyStylingWrapper = forwardRef(function FloatyStylingWrapper({
  menuPosition,
  children,
  zIndex = 9998
}, ref) {
  const isTemplate = useStore(({ currentDocument }) => currentDocument?.type === 'template')
  const accentColor = getPrimaryDark(isTemplate)
  if (menuPosition.top === null || menuPosition.left === null) return null

  return (
    <div
      ref={ref}
      // Masquée tant que le volet « Édition rapide » est ouvert (index.less).
      className='floaty-styling-wrapper'
      style={{
        position: 'absolute',
        zIndex,
        // Pastille au bleu marine du thème (logo) : ressort mieux que l'ancien
        // gris et cadre les boutons blancs. Theme-aware (navy proposition /
        // indigo template), cohérent avec le reste de l'UI.
        background: accentColor,
        padding: '5px 7px',
        borderRadius: 8,
        boxShadow: '0 4px 14px rgba(11, 34, 57, 0.28)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        ...menuPosition
      }}
      onMouseDown={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
    >
      {children}
    </div>
  )
})

export default FloatyStylingWrapper
